<button [disabled]="loading || disabled" [color]="color" [type]="type" mat-flat-button>
  <div class="button-content">
    @if (loading) {
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="20"></mat-progress-spinner>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</button>
